import { render, staticRenderFns } from "./NewCampaignUrl.vue?vue&type=template&id=633d5526&"
import script from "./NewCampaignUrl.vue?vue&type=script&lang=js&"
export * from "./NewCampaignUrl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports